import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase-config.js';

// DOM Elements
const myVideo = document.getElementById('myvideo');
const videoDisplayUI = document.getElementById('video-wrapper');
const videoPlayButton = document.getElementById('video-play-btn');
const videoPlayButtonWrapper = document.getElementById('video-play-btn-wrapper');
const theWizDesktop = document.getElementById('the-wiz-desktop');

// Video state
var videoHasStarted = false;

// Video captions data
let jsonCaptions = [
    {
      "start": "00:00:00.150",
      "end": "00:00:07.000",
      "text": "Let's face it. Your company, your products, your services, and your ideas, need design."
  },
  {
      "start": "00:00:07.500",
      "end": "00:00:12.500",
      "text": "However, employing staff or hiring contractors can get expensive."
  },
  {
      "start": "00:00:13.000",
      "end": "00:00:21.000",
      "text": "Experienced employees are now demanding upwards of over $100,000 per year plus benefits."
  },
  {
      "start": "00:00:21.150",
      "end": "00:00:26.000",
      "text": "And with freelancers, you never know exactly what you're gonna get, and when."
  },
  {
      "start": "00:00:26.250",
      "end": "00:00:33.000",
      "text": "Maybe you've considered hiring a big design agency to get the top-tier quality work that your business deserves."
  },
  {
      "start": "00:00:33.500",
      "end": "00:00:37.000",
      "text": "But we won't even begin to talk about how expensive that can be."
  },
  {
      "start": "00:00:37.250",
      "end": "00:00:47.500",
      "text": "And with all of these options, you still have the hassle of endless contract negotiations and time-consuming meetings when you just need to get something done."
  },
  {
      "start": "00:00:47.750",
      "end": "00:00:49.500",
      "text": "Nobody has time for that."
  },
  {
      "start": "00:00:50.000",
      "end": "00:00:59.500",
      "text": "What if there was a better way to get professional, agency-quality design work, while protecting your time, and at a fraction of the price?"
  },
  {
      "start": "00:01:00.000",
      "end": "00:01:03.250",
      "text": "Introducing… Design Magic."
  },
  {
      "start": "00:01:03.750",
      "end": "00:01:09.000",
      "text": "Your personal, in-house design agency that just works, like magic!"
  },
  {
      "start": "00:01:09.250",
      "end": "00:01:11.000",
      "text": "So, how do we do it?"
  },
  {
      "start": "00:01:11.250",
      "end": "00:01:17.500",
      "text": "With Design Magic we offer design subscription plans that take the guesswork out of the process."
  },
  {
      "start": "00:01:18.000",
      "end": "00:01:24.500",
      "text": "With a design subscription, you'll be able to eliminate those time-consuming contract negotiations and meetings…"
  },
  {
      "start": "00:01:24.750",
      "end": "00:01:27.500",
      "text": "receive unlimited design requests…"
  },
  {
      "start": "00:01:27.750",
      "end": "00:01:34.500",
      "text": "and receive professional quality design work all for one convenient, low monthly price."
  },
  {
      "start": "00:01:35.000",
      "end": "00:01:37.250",
      "text": "So how does it all work?"
  },
  {
      "start": "00:01:37.500",
      "end": "00:01:41.500",
      "text": "First, subscribe to a design plan that's right for your business."
  },
  {
      "start": "00:01:42.000",
      "end": "00:01:47.500",
      "text": "You'll immediately be paired with one of our expert designers who will service your requests."
  },
  {
      "start": "00:01:47.750",
      "end": "00:01:50.500",
      "text": "Submit unlimited design requests."
  },
  {
      "start": "00:01:50.750",
      "end": "00:01:57.500",
      "text": "If a design request is too large, your designer will work with you to break it down into more manageable requests."
  },
  {
      "start": "00:01:58.000",
      "end": "00:02:06.000",
      "text": "All requests are worked on and delivered on a one-at-a time basis to ensure the quality that your business deserves."
  },
  {
      "start": "00:02:06.250",
      "end": "00:02:09.000",
      "text": "Have a question or want to share your ideas?"
  },
  {
      "start": "00:02:09.500",
      "end": "00:02:14.500",
      "text": "All communication, questions, and collaboration will be handled through Slack."
  },
  {
      "start": "00:02:14.750",
      "end": "00:02:20.000",
      "text": "This will reduce the need for lengthy meetings and give you more of your time back."
  },
  {
      "start": "00:02:20.500",
      "end": "00:02:28.000",
      "text": "Once all of the information is gathered, your designer will work their magic and bring your design request to life."
  },
  {
      "start": "00:02:29.000",
      "end": "00:02:33.500",
      "text": "You'll receive updates to your design request in 1-2 business days."
  },
  {
      "start": "00:02:33.750",
      "end": "00:02:40.000",
      "text": "If you are not 100% satisfied with your design, we'll keep refining it until you are."
  },
  {
      "start": "00:02:40.250",
      "end": "00:02:46.750",
      "text": "Still have questions or want to learn more? Feel free to speak to one of our representatives in the chat below."
  },
  {
      "start": "00:02:47.000",
      "end": "00:02:53.500",
      "text": "We can't wait to hear more about your business and design needs and we look forward to working with you."
  },
  {
      "start": "00:02:53.750",
      "end": "00:03:01.000",
      "text": "Design Magic – Your personal, in-house design agency that works, like magic!"
  }
];

// Convert JSON captions to VTT format
function convertJsonToVtt(jsonCaptions) {
  let vttString = 'WEBVTT\n\n';
  jsonCaptions.forEach((caption, index) => {
      vttString += `${index + 1}\n${caption.start} --> ${caption.end}\n${caption.text}\n\n`;
  });
  return vttString;
}

function createDataUrl(vttString) {
  let encodedVtt = encodeURIComponent(vttString);
  return `data:text/vtt;charset=utf-8,${encodedVtt}`;
}

// Setup video captions
let vttString = convertJsonToVtt(jsonCaptions);
let vttDataUrl = createDataUrl(vttString);

let trackElement = document.createElement('track');
trackElement.setAttribute('kind', 'subtitles');
trackElement.setAttribute('label', 'English');
trackElement.setAttribute('srclang', 'en');
trackElement.setAttribute('src', vttDataUrl);
myVideo.appendChild(trackElement);

// Hide default video controls initially
myVideo.controls = false;

// Video event listeners
videoDisplayUI.addEventListener("mouseover", hoverOverVideo);
videoDisplayUI.addEventListener("mouseout", hoverOutOfVideo);
videoDisplayUI.addEventListener("click", clickVideo);

myVideo.addEventListener("play", (event) => {
  animateOutTheWizDesktopPartially();
  logEvent(analytics, 'video_played');
});

myVideo.addEventListener("pause", (event) => {
  animateInTheWizDesktop();
});

myVideo.addEventListener("ended", (event) => {
  logEvent(analytics, 'video_completed');
  animateInTheWizDesktop();
});

// Video interaction functions
function hoverOverVideo() {
  if (myVideo.currentTime == 0) {
    if (window.innerWidth <= 767) {
      videoPlayButton.style.width = 95 + "px";
      videoPlayButton.style.height = 95 + "px";
    }
    if (window.innerWidth > 767 && window.innerWidth <= 1024) {
      videoPlayButton.style.width = 120 + "px";
      videoPlayButton.style.height = 120 + "px";
    }
    if (window.innerWidth > 1023) {
      videoPlayButton.style.width = 145 + "px";
      videoPlayButton.style.height = 145 + "px";
    }
  }
}

function hoverOutOfVideo() {
  if (myVideo.currentTime == 0) {
    if (window.innerWidth <= 767) {
      videoPlayButton.style.width = 75 + "px";
      videoPlayButton.style.height = 75 + "px";
    }
    else if (window.innerWidth > 767 && window.innerWidth <= 1024) {
      videoPlayButton.style.width = 100 + "px";
      videoPlayButton.style.height = 100 + "px";
    }
    else if (window.innerWidth > 1023) {
      videoPlayButton.style.width = 125 + "px";
      videoPlayButton.style.height = 125 + "px";
    }
  }
}

function resetPlayButtonSize() {
  if (window.innerWidth <= 767) {
    videoPlayButton.style.width = 75 + "px";
    videoPlayButton.style.height = 75 + "px";
  }
  else if (window.innerWidth > 767 && window.innerWidth < 1024) {
    videoPlayButton.style.width = 100 + "px";
    videoPlayButton.style.height = 100 + "px";
  }
  else if (window.innerWidth > 1023) {
    videoPlayButton.style.width = 125 + "px";
    videoPlayButton.style.height = 125 + "px";
  }
}

function clickVideo() {
  if (!videoHasStarted) {
    videoHasStarted = true;
    videoPlayButton.classList.add('video-play-btn-fade-out');
    setTimeout(activateDefaultVideoControls, 350);
    myVideo.play();
  }
}

function activateDefaultVideoControls() {
  videoPlayButtonWrapper.style.display = 'hidden';
  myVideo.controls = true;
}

// Wiz desktop character animation (tied to video state)
function animateInTheWizDesktop() {
  if (window.innerWidth >= 1333) {
    if (myVideo.paused) {
      theWizDesktop.classList.remove("the-wiz-desktop-show-partially");
      theWizDesktop.classList.add("the-wiz-desktop-show");
    }
  }
  else {
    theWizDesktop.classList.remove("the-wiz-desktop-show");
  }
}

function animateOutTheWizDesktopPartially() {
  if (window.innerWidth >= 1333) {
    theWizDesktop.classList.remove("the-wiz-desktop-show");
    theWizDesktop.classList.add("the-wiz-desktop-show-partially");
  }
}

// Window resize handlers
window.addEventListener('resize', resetPlayButtonSize);
window.addEventListener('resize', animateInTheWizDesktop);

// Export functions that might be needed by other modules
export { animateInTheWizDesktop };
